export default __webpack_public_path__ + "static/media/teams.112b7442.svg";